import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import Spinner from '@components/spinner'
import FilterGroup from '@components/FilterGroup'
import { Autocomplete, TagsInput } from '@components/Autocomplete'
import RichTextEditor from '@components/RichTextEditor'
import Button from '@components/Button'
import Attachment from '@components/Attachment'
import { showDialog, isCancellationError } from '@components/Dialog'
import { fireDialog } from './dialogHelpers'
import { Dropdown } from '@components/Autocomplete'

import { eplApi, employeeApi, fileApi } from '@atheneum/api'


// regex taken from yup
// eslint-disable-next-line
const rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i

class SendEmails extends Component {
  static propTypes = {
    extractEplStore: PropTypes.object,
    history: PropTypes.object,
    staticData: PropTypes.object,
    growlStore: PropTypes.object,
    projectStore: PropTypes.object,
    returnToPreview: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.state = {
      from: props.extractEplStore.from,
      clients: props.extractEplStore.clients,
      atheneumContacts: props.extractEplStore.atheneumContacts,
      attachments: [],
      fromError: null,
      toError: null,
      ccError: null,
      subjectError: null
    }

    props.extractEplStore.generateAndSavePreview(false)
  }

  returnToEplView = (keepSelection = true) => {
    const { history, extractEplStore } = this.props
    const pathname = history.location.pathname.replace(
      /extract-epls.*/g,
      'experts-pipeline'
    )
    const state = keepSelection
      ? { selectedEpls: extractEplStore.selectedEpls.map(epl => epl.id) }
      : null
    history.push({
      pathname,
      state
    })
  }

  submit = () => {
    const { extractEplStore, projectStore, growlStore } = this.props
    const { selectedTemplate, templatePreview, selectedEpls } = extractEplStore
    const { subject, content } = templatePreview

    const MBLimit = 50
    let attachmentSize = 0
    this.state.attachments.forEach(attachment => {
      attachmentSize += attachment.size / 1000000
    })

    if (attachmentSize > MBLimit) {
      return showDialog({
        title: 'Attachments size exceeds limit of maximum 50MB',
        type: 'error'
      }).catch(err => isCancellationError(err))
    }

    return eplApi
      .sendExtractEplEmail({
        from: this.state.from.id,
        to: this.state.clients.map(client => client.email),
        cc: this.state.atheneumContacts.map(athContact => athContact.email),
        subject,
        content,
        attachmentIds: this.state.attachments.map(att => att.id),
        templateName: selectedTemplate.name,
        eplIds: selectedEpls.map(epl => epl.id),
        project: projectStore.project
      })
      .then(() => {
        growlStore.showSuccess('Extract EPLs email successfully sent')
        this.returnToEplView(false)
      })
      .catch(err => growlStore.showError(err))
  }

  render() {
    const { extractEplStore, staticData, growlStore } = this.props
    const {
      templatePreview,
      clients,
      loadingPreview,
      selectedTemplateType,
      templateOptions
    } = extractEplStore

    if (loadingPreview) return <Spinner />

    const { EMPLOYEE_POSITIONS } = staticData.CONST
    const employeePositions = [
      EMPLOYEE_POSITIONS.ASSOCIATE,
      EMPLOYEE_POSITIONS.TEAM_LEADER,
      EMPLOYEE_POSITIONS.ACCOUNT_MANAGER,
      EMPLOYEE_POSITIONS.PRINCIPAL,
      EMPLOYEE_POSITIONS.ASSOCIATE_INTERN
    ]

    return (
      <div className="extract-epls m-t-xl">
        <FilterGroup label="Select template">
          <Dropdown
            selectedItem={selectedTemplateType}
            itemToString={item => item && item.name}
            onChange={template => {
              this.state.mode === 'template'
                ? fireDialog(() =>
                    this.props.extractEplStore.setTemplate(template)
                  )
                : this.props.extractEplStore.setTemplate(template)
            }}
            options={templateOptions}
          />
        </FilterGroup>
        <FilterGroup label="FROM">
          <Autocomplete
            error={this.state.fromError}
            value={this.state.from}
            itemToString={item => item && item.fullName}
            onChange={option => {
              let fromError = null
              if (!option) {
                fromError = 'FROM field cannot be blank'
              }
              this.setState({ from: option, fromError })
            }}
            loadOptions={query =>
              employeeApi.typeaheadSearch(employeePositions, query)
            }
          />
          <div className="text-wrapper--error">{this.state.fromError}</div>
        </FilterGroup>
        <FilterGroup label="TO">
          <TagsInput
            creatable
            error={this.state.toError}
            value={this.state.clients}
            itemToString={item => item && item.fullName}
            itemFromCreatable={email => ({
              email: email.trim(),
              fullName: email.trim()
            })}
            onChange={option => {
              let toError = null
              if (!option.length) {
                toError = 'TO field cannot be blank'
              }
              if (option.length && option.find(o => !rEmail.test(o.email))) {
                toError = 'Email format is not valid'
              }
              this.setState({ clients: option, toError })
              this.props.extractEplStore.generateAndSavePreview([...option, ...this.state.atheneumContacts])
            }}
            options={clients}
          />
          <div className="text-wrapper--error">{this.state.toError}</div>
        </FilterGroup>
        <FilterGroup label="CC">
          <TagsInput
            creatable
            error={this.state.ccError}
            value={this.state.atheneumContacts}
            itemToString={item => item && item.fullName}
            itemFromCreatable={email => ({
              email: email.trim(),
              fullName: email.trim()
            })}
            onChange={option => {
              let ccError = null
              if (option.length && option.find(o => !rEmail.test(o.email))) {
                ccError = 'Email format is not valid'
              }
              this.setState({ atheneumContacts: option, ccError })
              this.props.extractEplStore.generateAndSavePreview([...option, ...this.state.clients])
            }}
            loadOptions={query =>
              employeeApi.typeaheadSearch(employeePositions, query)
            }
          />
          <div className="text-wrapper--error">{this.state.ccError}</div>
        </FilterGroup>
        <FilterGroup label="Subject">
          <div
            className={
              !templatePreview.subject ? 'expert-form__input-group--error' : ''
            }>
            <input
              value={templatePreview.subject}
              onChange={e => {
                let subjectError = null
                if (!e.target.value) {
                  subjectError = 'Subject field cannot be blank'
                }
                this.setState({ subjectError })
                templatePreview.subject = e.target.value
              }}
            />
          </div>
          <div className="text-wrapper--error">{this.state.subjectError}</div>
        </FilterGroup>
        <FilterGroup
          label={
            <div className="flex-center">
              <div className="m-r-sm">Content</div>
            </div>
          }>
          <div
            className="no-p-margins"
            style={{ fontFamily: 'Calibri', fontSize: '11pt' }}>
            <RichTextEditor
              skipWrapper
              isExtractEplsDraft
              toolbarInline
              error={
                !templatePreview.content
                  ? 'Content field cannot be blank'
                  : null
              }
              value={templatePreview.content}
              onChange={val => {
                templatePreview.content = val
              }}
            />
          </div>
          <div className="m-t-lg">
            <Attachment
              attachments={this.state.attachments}
              tooltip="Click to add attachments"
              onOk={({ data }) => {
                this.setState({
                  attachments: [...this.state.attachments, data[0]]
                })
              }}
              onDelete={fileId => {
                fileApi.deleteFile(fileId).then(() => {
                  const attachments = this.state.attachments.filter(
                    atch => atch.id !== fileId
                  )
                  this.setState({ attachments })
                })
              }}
              label="Add attachment"
              url="/api/file"
            />
          </div>
        </FilterGroup>
        <div className="expert-form__section">
          <Button secondary onClick={() => fireDialog(this.returnToEplView)}>
            Cancel
          </Button>
          <Button
            secondary
            onClick={() =>
              fireDialog(() =>
                this.props.extractEplStore.generateAndSavePreview(false)
              )
            }>
            Reset
          </Button>
          <Button
            primary
            disabled={
              this.state.fromError ||
              this.state.toError ||
              this.state.ccError ||
              this.state.subjectError ||
              !templatePreview.content
            }
            onClick={this.submit}>
            Send
          </Button>
        </div>
      </div>
    )
  }
}

export default inject(
  'extractEplStore',
  'projectStore',
  'staticData',
  'growlStore'
)(observer(SendEmails))
